"use client";

import {
  ChevronDown as ArrowDownIcon,
  ChevronUp as ArrowUpIcon,
} from "lucide-react";
import { Heading } from "@app/_components/ui";
import { Accordion, Button } from "@components/ngg";
import Link from "next/link";
import xss from "xss";
import { translations } from "./translations";

const Icon = ({ open }: { open: boolean }) => {
  if (open) return <ArrowUpIcon strokeWidth={1} className="size-4.5" />;
  return <ArrowDownIcon strokeWidth={1} className="size-4.5" />;
};

export const FurnishingAccordion = ({ locale }: { locale: string }) => {
  return (
    <div className="flex w-full flex-col px-4 pb-16 lg:self-center lg:pb-32 xl:max-w-screen-lg">
      <div className="child:border-b flex flex-col border-gray-300">
        <div>
          <Heading as="h5" size={{ initial: 5, lg: 4 }} className="pb-4">
            {translations[locale].questionsTitle}
          </Heading>
        </div>
        {translations[locale].questions.map((question) => (
          <Accordion
            IconComponent={Icon}
            transitionProps={{ appear: false }}
            classNames={{
              button:
                "text-left items-center leading-4 py-5 px-0 font-normal  text-base lg:text-lg",
              panel: "pb-5 pt-0 pl-0  text-base lg:text-lg",
            }}
            title={question.title}
            key={question.title}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: xss(question.content),
              }}
            />
          </Accordion>
        ))}
      </div>
      <p className="border-b-0 pt-6 text-center text-base text-gray-500 lg:text-base">
        {translations[locale].questionsSubtitle} <br className="lg:hidden" />
        <span className="text-black underline">
          <Link href={"/kontakt"}>{translations[locale].questionsLink}</Link>
        </span>
      </p>
      <Button
        type="button"
        as={Link}
        target="_blank"
        href={translations[locale].bookingLink}
        fullWidth
        className="btn-primary mt-10 h-12 max-w-sm self-center lg:mt-20 lg:text-lg print:hidden"
      >
        {translations[locale].questionsCTA}
      </Button>
    </div>
  );
};
